import StageBg001 from "@assets/imgs/stages/001-stage-bg.png";
import StageBg002 from "@assets/imgs/stages/002-stage-bg.png";
import StagePreview001 from "@assets/imgs/stages/001-stage-preview.png";
import StagePreview002 from "@assets/imgs/stages/002-stage-preview.png";
import type { StageConfig } from "@/phaser/core/monsters/monsterCatalog";

export type StageId = "stage-001" | "stage-002";

export type StageMeta = {
  id: StageId;

  previewKey: string;
  previewSrc: string;

  bgKey: string;
  bgSrc: string;

  config: StageConfig;
};

const SEA_VS_DESERT: StageConfig = {
  id: "stage-config-001",
  leftHabitat: "SEA",
  rightHabitat: "DESERT",
  obstacleIds: ["obstacle-001", "obstacle-002"],
};

const FOREST_VS_FACTORY: StageConfig = {
  id: "stage-config-002",
  leftHabitat: "FOREST",
  rightHabitat: "FACTORY",
  obstacleIds: ["obstacle-003", "obstacle-004"],
};

export const STAGES: StageMeta[] = [
  {
    id: "stage-001",
    previewKey: "stage-preview-001",
    previewSrc: StagePreview001,
    bgKey: "stage-bg-001",
    bgSrc: StageBg001,
    config: SEA_VS_DESERT,
  },
  {
    id: "stage-002",
    previewKey: "stage-preview-002",
    previewSrc: StagePreview002,
    bgKey: "stage-bg-002",
    bgSrc: StageBg002,
    config: FOREST_VS_FACTORY,
  },
];

export const getStageMetaById = (id: StageId) =>
  STAGES.find((s) => s.id === id) ?? STAGES[0];
